import { render } from "./FormCdlDipendente.vue?vue&type=template&id=bd8592c2"
import script from "./FormCdlDipendente.vue?vue&type=script&lang=js"
export * from "./FormCdlDipendente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__